import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';

export default function ClientesPDFExport({ clientes }) {
  const exportToPDF = () => {
    const doc = new jsPDF();
    const currentDate = new Date().toLocaleDateString('es-ES');
    
    // Configuración de página
    const pageHeight = doc.internal.pageSize.height;
    const pageWidth = doc.internal.pageSize.width;
    const margin = 15;
    
    // Título del documento - mejorado
    doc.setFontSize(18);
    doc.setFont('helvetica', 'bold');
    doc.setTextColor(40, 40, 40);
    
    // Centrar el título
    const titleText = 'Lista de Clientes - Control de Tóner';
    const titleWidth = doc.getTextWidth(titleText);
    const titleX = (pageWidth - titleWidth) / 2;
    doc.text(titleText, titleX, 25);
    
    // Línea decorativa bajo el título
    doc.setDrawColor(66, 139, 202);
    doc.setLineWidth(0.5);
    doc.line(margin, 30, pageWidth - margin, 30);
    
    // Preparar datos para la tabla con mejor manejo de texto
    const tableData = clientes.map(cliente => [
      cliente.nombre || '',
      cliente.dia_facturacion !== null && cliente.dia_facturacion !== undefined ? cliente.dia_facturacion.toString() : '',
      '', // Nro Factura - espacio en blanco
      '', // Fecha - espacio en blanco
      cliente.toma_contador || '',
      cliente.ubicacion || ''
    ]);
    
    // Configurar la tabla con mejor formato
    autoTable(doc, {
      head: [['Nombre', 'Día', 'Nro Factura', 'Fecha', 'Contador', 'Ubicación']],
      body: tableData,
      startY: 40,
      styles: {
        fontSize: 9,
        cellPadding: 3,
        overflow: 'linebreak',
        cellWidth: 'wrap',
        valign: 'middle',
        halign: 'left'
      },
      headStyles: {
        fillColor: [66, 139, 202],
        textColor: [255, 255, 255],
        fontStyle: 'bold',
        fontSize: 10,
        halign: 'center',
        valign: 'middle'
      },
      columnStyles: {
        0: { 
          cellWidth: 50, 
          halign: 'left',
          overflow: 'linebreak'
        }, // Nombre
        1: { 
          cellWidth: 15, 
          halign: 'center' 
        }, // Día
        2: { 
          cellWidth: 30, 
          halign: 'center' 
        }, // Nro Factura
        3: { 
          cellWidth: 25, 
          halign: 'center' 
        }, // Fecha
        4: { 
          cellWidth: 25, 
          halign: 'center' 
        }, // Contador
        5: { 
          cellWidth: 37, 
          halign: 'left',
          overflow: 'linebreak'
        }, // Ubicación
      },
      alternateRowStyles: {
        fillColor: [248, 249, 250]
      },
      margin: { 
        top: 40, 
        left: margin, 
        right: margin, 
        bottom: 60 
      },
      didDrawPage: function (data) {
        // Obtener la posición final de la tabla
        const finalY = data.cursor ? data.cursor.y : (data.table && data.table.finalY ? data.table.finalY : 100);
        
        // Solo agregar elementos del pie si hay suficiente espacio
        if (finalY < pageHeight - 55) {
          // Espacio antes del pie de página
          const footerStartY = Math.max(finalY + 20, pageHeight - 50);
          
          // Línea separadora
          doc.setDrawColor(180, 180, 180);
          doc.setLineWidth(0.3);
          doc.line(margin, footerStartY, pageWidth - margin, footerStartY);
          
          // Pregunta sobre orden de compra
          doc.setFontSize(11);
          doc.setFont('helvetica', 'normal');
          doc.setTextColor(60, 60, 60);
          doc.text('¿Espera orden de compra del mes anterior?', margin, footerStartY + 15);
          
          // Línea para respuesta - mejor posicionada
          doc.setDrawColor(100, 100, 100);
          doc.setLineWidth(0.5);
          const lineStartX = margin + doc.getTextWidth('¿Espera orden de compra del mes anterior?') + 10;
          doc.line(lineStartX, footerStartY + 15, pageWidth - margin, footerStartY + 15);
        }
        
        // Información del pie de página - siempre en la parte inferior
        const footerY = pageHeight - 15;
        
        // Fecha de generación
        doc.setFontSize(8);
        doc.setTextColor(120, 120, 120);
        doc.setFont('helvetica', 'normal');
        doc.text(`Fecha de generación: ${currentDate}`, margin, footerY);
        
        // Número de página - alineado a la derecha
        const pageText = `Página ${data.pageNumber}`;
        const pageTextWidth = doc.getTextWidth(pageText);
        doc.text(pageText, pageWidth - margin - pageTextWidth, footerY);
      },
      // Mejorar el manejo de páginas
      showHead: 'everyPage',
      pageBreak: 'auto',
      rowPageBreak: 'avoid'
    });
    
    // Guardar el PDF con nombre más descriptivo
    const fileName = `lista_clientes_${currentDate.replace(/\//g, '-')}.pdf`;
    doc.save(fileName);
  };

  return (
    <button
      onClick={exportToPDF}
      className="bg-green-600 hover:bg-green-700 text-white px-4 py-2 rounded shadow flex items-center gap-2 transition-colors duration-200"
      title="Exportar lista de clientes a PDF"
    >
      <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 10v6m0 0l-3-3m3 3l3-3m2 8H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
      </svg>
      Exportar PDF
    </button>
  );
}
